import https from "./https";

export const verifyBank = async data => {

    try {
        return await https.post("/widget/verify-bank", data)
    } catch (err) {
        throw err;
    }
}